import { render, staticRenderFns } from "./MensagemForm.vue?vue&type=template&id=3ea9e93d"
import script from "./MensagemForm.vue?vue&type=script&lang=ts"
export * from "./MensagemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports